import { createStore } from 'satcheljs';
import InboxPlusStore from './schema/InboxPlusStore';

const inboxPlusStore: InboxPlusStore = {
    inboxPlusPivots: [],
    isPivotEnableDisableDialogShown: false,
};

export let getStore = createStore<InboxPlusStore>('inboxPlusStore', inboxPlusStore);

const store = getStore();
export default store;
